export default __webpack_public_path__ + "static/graphql-logo-d5597db141841bf444d3b68a33f58c84.png";